export default "__VITE_ASSET__DkiBCNF1__"